import { EventEmitter, Output, Input, Component, OnDestroy } from '@angular/core';
import { BasePropertyComponent } from './base-property-component';

@Component({
    template: ''
})
export abstract class NewBasePropertyTextBox<T> extends BasePropertyComponent<T> implements OnDestroy {

    @Input() override modelUpdate: boolean = true;
    @Input() updateOnBlur: boolean;
    @Input() updateOnFocusOut: boolean;
    @Input() placeholder: string = '';
    @Input() tabIndex: number;
    @Input() isDisabled: boolean = false;
    
    @Output() onInputChange = new EventEmitter();
    @Output() keyDown: EventEmitter<KeyboardEvent> = new EventEmitter();
    @Output() focusOut = new EventEmitter();
    @Output() blur = new EventEmitter();

    abstract get inputValue(): T;
    
    override init(): void {
        super.init();
        this.input.tabIndex = this.tabIndex;
    }

    override ngOnDestroy(): void {

        super.ngOnDestroy();

        this.onInputChange?.complete();
        this.onInputChange = null;
        
        this.keyDown?.complete();
        this.keyDown = null;

        this.focusOut?.complete();
        this.focusOut = null;

        this.blur?.complete();
        this.blur = null;
    }

    updateModel() {
        const inputValue = this.inputValue;

        this.valueChange.emit(inputValue);
        const pvmValue = this.propertyViewModel.value;

        if (!this.modelUpdate ||
            (pvmValue == null &&
                (inputValue == null || (typeof inputValue === 'string' && inputValue === '')
                )
            ) || (pvmValue === inputValue)) {
            return;
        }

        this.propertyViewModel.value = inputValue;
    }
   
    onInput(e: Event) {
        if (!this.updateOnBlur) {
            this.updateModel();
        }
        this.onInputChange.emit(e)
    }

    onFocusOut(e: Event) {
        if (this.updateOnFocusOut) {
            this.updateModel();
        }
        this.focusOut.emit(e);
    }

    onBlur(e) {
        if (!this.isDisabled && this.propertyViewModel.isEnabled) {
            if (this.updateOnBlur) {
                this.updateModel();
            }
            this.propertyViewModel.validate();
        }
        this.blur.emit(e);
    }

    protected onKeyDown(ev: KeyboardEvent) {
        this.keyDown.emit(ev);
    }
}
